import unauthorized from './unauthorized';

export default {
  unauthorized,
};



// WEBPACK FOOTER //
// ./src/pages/error/index.js